export enum Permission {
  // TIPOS DE PERFIL
  QUEBRADEIRA = 'is_quebradeira',
  FAMILIAR = 'is_familiar',
  ENTREPOSTO = 'is_entreposto',
  PARCEIRO = 'is_parceiro',
  DIRECAO = 'is_direcao',
  ASSESSORIA = 'is_assessoria',
  // COORDENADORAS E ASSOCIADAS
  COORDENADORA_GRUPO = 'is_coordinator_grupo',
  ASSOCIADA_ASMUBIP = 'is_associated_asmubip',
  COORDENADORA_ASMUBIP = 'is_coordinator_asmubip',
  COORDENADORA_ENTREPOSTO = 'is_manager_entreposto',
  SUPERADMIN = 'is_superadmin',
}

export function getPermissionLabel({ permission }: { permission: Permission }): string {
  switch (permission) {
    case Permission.QUEBRADEIRA:
      return 'Quebradeira';
    case Permission.FAMILIAR:
      return 'Familiar';
    case Permission.ENTREPOSTO:
      return 'Entreposto';
    case Permission.PARCEIRO:
      return 'Parceiro';
    case Permission.DIRECAO:
      return 'Direção';
    case Permission.ASSESSORIA:
      return 'Assessoria';
    case Permission.COORDENADORA_GRUPO:
      return 'Coordenadora do Grupo';
    case Permission.ASSOCIADA_ASMUBIP:
      return 'Associada da ASMUBIP';
    case Permission.COORDENADORA_ASMUBIP:
      return 'Coordenadora da ASMUBIP';
    case Permission.COORDENADORA_ENTREPOSTO:
      return 'Coordenadora do Entreposto';
    case Permission.SUPERADMIN:
      return 'Super Admin';
  }
}

export const GENERAL_ADMINS = [
  // Permission.DIRECAO,
  Permission.ASSESSORIA,
  Permission.SUPERADMIN,
  // Permission.COORDENADORA_ASMUBIP,
];

export const GROUP_VIEWS = [
  Permission.QUEBRADEIRA,
  Permission.FAMILIAR,
  Permission.COORDENADORA_GRUPO,
];

export const COMMUNITY_VIEWS = [
  Permission.QUEBRADEIRA,
  Permission.FAMILIAR,
  Permission.COORDENADORA_GRUPO,
];

export const ENTREPOSTO_VIEWS = [Permission.ENTREPOSTO, Permission.COORDENADORA_ENTREPOSTO];

export const CAN_REVIEW_FLOCOS = [
  ...ENTREPOSTO_VIEWS,
  // ...GENERAL_ADMINS,
  // Permission.COORDENADORA_GRUPO,
];

export const NON_ENTREPOSTO_VIEWS = [
  Permission.QUEBRADEIRA,
  Permission.FAMILIAR,
  Permission.PARCEIRO,
  Permission.DIRECAO,
  Permission.ASSESSORIA,
  Permission.COORDENADORA_GRUPO,
  Permission.COORDENADORA_ASMUBIP,
];
